<bdg-label type="title">Demonstrativo de pagamento do residente</bdg-label>
<div class="demonstrativo mt-3 mb-3" style="border: solid 1px rgb(33, 33, 33, 0.08)">
  <div class="row">
    <bdg-label class="col" type="subheading-1">Valor total da bolsa</bdg-label>
    <bdg-label class="col text-right" type="subheading-2">{{ demonstrativo?.valorBolsa | currency }}</bdg-label>
  </div>

  <mat-divider></mat-divider>

  <div class="falta-text">
    <div class="row" *ngFor="let falta of faltas">
      <bdg-label class="col" type="subheading-2">{{ getDescricaoCompletaRegistro(falta) }}</bdg-label>
    </div>
  </div>

  <div class="row mt-1">
    <bdg-label class="col-12 col-sm" type="subheading-1">Desconto total de faltas</bdg-label>
    <bdg-label [class]="valorDescontosClass(false)" type="subheading-2">{{
      -1 * demonstrativo?.valorDescontos | currency
    }}</bdg-label>
  </div>

  <div class="falta-text">
    <div class="row" *ngFor="let compensacao of compensacoes">
      <bdg-label class="col" type="subheading-2">{{ getDescricaoCompletaRegistro(compensacao) }}</bdg-label>
    </div>
  </div>

  <div class="row mt-1">
    <bdg-label class="col" type="subheading-1">{{ valorAditivosDesc }}</bdg-label>
    <bdg-label [class]="valorAditivosClass" type="subheading-2">
      {{ !isValorAditivosZero ? '+' : '' }}{{ demonstrativo?.valorAditivos | currency }}</bdg-label
    >
  </div>

  <mat-divider></mat-divider>

  <div class="row">
    <bdg-label class="col" type="subheading-1">Valor total do mês</bdg-label>
    <bdg-label class="col text-right" type="subheading-2">{{ demonstrativo?.valorBaseInss | currency }}</bdg-label>
  </div>

  <div class="row">
    <bdg-label class="col" type="subheading-1">Desconto INSS - 11%</bdg-label>
    <bdg-label [class]="valorDescontosClass(true)" type="subheading-2">{{
      -1 * demonstrativo?.valorDescontoInss | currency
    }}</bdg-label>
  </div>

  <mat-divider></mat-divider>

  <div class="row">
    <bdg-label class="col" type="subheading-1">Valor líquido</bdg-label>
    <bdg-label class="col text-right" type="subheading-2">{{ demonstrativo?.valorLiquido | currency }}</bdg-label>
  </div>

  <div class="row mt-2">
    <bdg-label class="col obs-faltas-text" type="caption">{{ faltasText }}</bdg-label>
  </div>
</div>
